import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteReading,
  getReading,
  restoreReading,
  updateReading,
} from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditReading() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateReading(id, title, description, image);
      if (result) {
        navigate("/readings/all");
      }
    } catch (error) {}
  };

  const publishReading = async (id) => {
    try {
      await restoreReading(id);

      navigate("/readings/all");
    } catch (error) {}
  };
  const unPublishReading = async (id) => {
    try {
      await deleteReading(id);

      navigate("/readings/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneReading = async (id) => {
    try {
      const result = await getReading(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.readingId}
          breadCrumbLink={"Readings"}
          breadCrumbText={"Edit News"}
          goBackLink={"/readings/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishReading}
          unPublishItem={unPublishReading}
          getOneItem={getOneReading}
        />
      </Container>
    </>
  );
}
